import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

import { LocaleService } from '@sm360/widget-commons-core-services';
import { InputNumber } from '@sm360/widget-commons-forms';
import { PurchaseMethodsV25, Quote } from '@sm360/widget-commons-vehicle';
import { LocalStorageService, AnalyticsService, TRACKING_TAGS as TAGS } from '@sm360/widget-commons-general';

import 'payment-calculator-v25/components/PaymentCalculatorDetails/components/CalculatorCashdown/CalculatorCashdown.scss';

class CalculatorCashdown extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            cashdown: props.purchaseMethods.getSelectedFinanceCashDown(),
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.cashDownAnalytics = this.cashDownAnalytics.bind(this);
        this.debounceCashDownAnalytics = debounce(this.cashDownAnalytics, 5000);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            cashdown: newProps.purchaseMethods.getSelectedFinanceCashDown(),
        });
    }

    onInputChange(value) {
        this.debounceCashDownAnalytics(value);
        const cashdown = parseFloat(Math.round(value * 100) / 100);
        this.setState({
            cashdown,
        });
        LocalStorageService.set('cashDown', cashdown);
        this.props.setCashDown(cashdown, this.props.config);
    }

    cashDownAnalytics(value) {
        if (value)
            AnalyticsService.ga4Trigger(
                TAGS.PAYMENT_CALCULATOR_INITIAL_CASHDOWN(
                    value,
                    this.props.quote.vehicle.model.name,
                    this.props.quote.vehicle.year
                )
            );
    }

    render() {
        const defaultCashdown = parseFloat(this.state.cashdown);
        return (
            <div className="calculator-cash-down is-light">
                <div className="calculator-cash-down-title">
                    {LocaleService.t('PAYMENT_CALCULATOR_V25.INITIAL_CASHDOWN')}
                </div>
                <div className="calculator-cash-down-wrapper">
                    <InputNumber
                        min={0}
                        onChange={this.onInputChange}
                        step={250}
                        value={defaultCashdown ? defaultCashdown.toFixed(2) : '0'}
                        decimalCount={2}
                        label="CASHDOWN"
                        showLabel={false}
                    />
                </div>
            </div>
        );
    }
}

CalculatorCashdown.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethodsV25.PurchaseMethodsModelV25).isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModelV25).isRequired,
    setCashDown: PropTypes.func.isRequired,
};

CalculatorCashdown.displayName = 'CalculatorCashdown';

export default CalculatorCashdown;
